export default __webpack_public_path__ + "static/media/CNo.48-0.628e628f.jpg";